/// <reference path="../../../../typings/tsd.d.ts" /> 
module warsApp.controllers {
    export interface IMapFunctionConfigurationScope extends angular.IScope {
        model: warsApp.models.MapFunctionConfigurationModel;
    }

    export class MapFunctionConfigurationController {
        constructor(scope: IMapFunctionConfigurationScope,
            mapConfigurationService: services.MapConfigurationService,
            private deleteService: services.DeleteService,
            $routeParams: angular.route.IRouteParamsService,
            systemLevelService:services.SystemLevelService) {
            const mapConfigurationId = $routeParams["mapConfigurationId"];

            scope.model = new models.MapFunctionConfigurationModel(mapConfigurationService, deleteService,systemLevelService, mapConfigurationId);
            console.log(scope);
        }
    }
}

warsApp.registerController('MapFunctionConfigurationController', ['$scope', 'mapConfigurationService', 'deleteService', '$routeParams','systemLevelService']);